import { render, staticRenderFns } from "./AccountDeliveryCostBase.vue?vue&type=template&id=13ecabc5&scoped=true&"
import script from "./AccountDeliveryCostBase.vue?vue&type=script&lang=ts&"
export * from "./AccountDeliveryCostBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ecabc5",
  null
  
)

export default component.exports